module.exports = __webpack_public_path__ + "static/bunkacho-b9ddf0a76efdc92addbfc7a3a1d62981.png";